import React, { useState } from "react"
import { useMarina } from "src/contexts/MarinaContext"

import Button from "src/components/Button"
import Form from "src/components/Form"
import OverflowMenu from "src/components/OverflowMenu"

import { getJobTemplateIds, getJobTemplates } from "src/api/Service"

import useDatatable from "src/hooks/use_datatable"
import useDebounce from "src/hooks/use_debounce"

import JobTemplatesTable from "./JobTemplatesTable"

const JobTemplates = () => {
  const { marinaSlug } = useMarina()
  const table = useDatatable({
    queryKey: ["jobTemplates", marinaSlug],
    fetchFn: getJobTemplates,
    defaultFilters: { search: "", status: "active" },
    fetchAllIds: (params) => getJobTemplateIds(params).then((r) => r.ids),
  })

  const [searchTerm, setSearchTerm] = useState(table.filters.search || "")

  const [debouncedSetSearch] = useDebounce((value) => {
    table.setFilter("search", value)
  })

  const handleClearSearch = () => {
    setSearchTerm("")
    debouncedSetSearch("")
    table.setFilter("search", "")
  }

  const handleSearch = (event) => {
    const value = event.target.value
    setSearchTerm(value)
    debouncedSetSearch(value.trim())
  }

  const handleStatusFilter = (status) => {
    table.setFilter("status", status)
  }

  const renderSearchInput = () => (
    <Form.IconTextField
      icon={
        <i className="fa-solid fa-magnifying-glass text-xl text-gray-400" />
      }
      id="job-templates-search"
      isClearable
      onChange={handleSearch}
      onClearSelection={handleClearSearch}
      position="left"
      value={searchTerm}
      placeholder="Search by template name"
    />
  )

  const renderStatusFilter = () => {
    const activeStatus = table.filters.status === "active"
    return (
      <OverflowMenu menuButtonLabel={activeStatus ? "Active" : "Archived"}>
        <OverflowMenu.Item
          label={activeStatus ? "Archived" : "Active"}
          onClick={() =>
            handleStatusFilter(activeStatus ? "archived" : "active")
          }
        />
      </OverflowMenu>
    )
  }

  return (
    <div className="bg-white px-2 lg:px-6">
      <div className="flex flex-col gap-4 pb-6 pt-4">
        <div className="mt-2 flex flex-col justify-between pb-6 lg:p-0 xl:flex-row">
          <div className="mb-2 w-full xl:m-0 xl:w-[336px]">
            {renderSearchInput()}
          </div>
          <div className="flex space-x-2 xl:justify-between">
            <div className="w-full sm:w-min">{renderStatusFilter()}</div>
            <Button
              variant="primary"
              onClick={() =>
                (window.location.href = `/manage/${marinaSlug}/service/job_templates/new`)
              }
            >
              + New Template
            </Button>
          </div>
        </div>
        <JobTemplatesTable table={table} status={table.filters.status} />
      </div>
    </div>
  )
}

export default JobTemplates
